import { parseJSON } from 'src/utils/json';
import getRequestHandler from '../common/getRequestHandler';
import ReqResChannel from '../core/ReqResChannel';
import { MsgInitiator } from '../types';
import WebModuleAPIs from './modules';
const requestHandler = getRequestHandler(WebModuleAPIs);
export const web2RNCom = new ReqResChannel(MsgInitiator.WEB, msg => {
    window?.ReactNativeWebView?.postMessage?.(JSON.stringify(msg));
}, requestHandler);
function handleMessageEvent(event) {
    if (typeof event.data === 'string') {
        const msg = parseJSON(event.data);
        if (msg) {
            web2RNCom.handleMsg(msg);
        }
    }
}
// ponytail: this module is web-bridge only; native can still import it via
// nav/debug graphs. document is undefined in RN — don't crash module init.
if (typeof document !== 'undefined') {
    window.addEventListener('message', handleMessageEvent, false);
    document.addEventListener('message', handleMessageEvent, false);
}
